const EmptyBed = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-empty-bed"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m21.5,12H1V2H0v20h1v-3h22v3h1v-7.5c0-1.378-1.121-2.5-2.5-2.5ZM1,18v-5h20.5c.827,0,1.5.673,1.5,1.5v3.5H1Z" />
    </svg>
  );
};

export default EmptyBed;
